import { render } from "./Footer.vue?vue&type=template&id=4339b8dc&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=4339b8dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4339b8dc"

export default script